import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useChainId } from '@occc-app/Chain/hooks';
import { SegmentCreateMutation } from '@occc/graphql';
import { snackbar } from '@occc-app/design-system';

import { SegmentCreatePage } from './segment-create.page';

import { SegmentFormValues } from '../../segments.types';
import { routeCreator } from '../../segments.router';
import { useCreateSegment } from '../../hooks/segments.mutation.hook';

export const SegmentCreateController = () => {
  const navigate = useNavigate();
  const chainId = useChainId();

  const onCompleted = (mutation: SegmentCreateMutation) => {
    const segment = mutation.segmentCreate;

    snackbar.success(`${segment.name} has been successfully created.`);
    navigate(routeCreator.details(segment.uuid));
  };

  const [segmentCreate] = useCreateSegment({
    onCompleted,
  });

  const onCancel = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const onSubmit = useCallback(
    async (values: SegmentFormValues) => {
      await segmentCreate({
        variables: {
          chainId,
          input: {
            description: values.description,
            name: values.name,
          },
        },
      });
    },
    [chainId, segmentCreate],
  );

  return <SegmentCreatePage onSubmit={onSubmit} onCancel={onCancel} />;
};
